export enum PROVIDER_FIELD_PERMISSIONS {
  PROVIDER_FIELD_VIEW = 'PROVIDER_FIELDVIEW',
  PROVIDER_FIELD_WRITE = 'PROVIDER_FIELDWRITE',
}
